import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router';

import DashboardsLayout from './DashboardsLayout';
import Error from './Error';

export default function App() {
  return (
    <RouterProvider
      router={createBrowserRouter(
        createRoutesFromElements(
          <Route element={<Outlet />} errorElement={<Error />}>
            <Route path="/:slug?" element={<DashboardsLayout />} />
          </Route>,
        ),
      )}
    />
  );
}
